export default "__VITE_ASSET__OS4AXpbN__"